import { camelizeKeys } from 'humps'
import CURRENCIES from '@/dataset/currencies.json'
import { deserializeJsonApi } from '@/utils/jsonApiDeserializer.js'
import {
  parseProjectionPreviewInput,
  type ProjectionPreviewInput,
  type ProjectionPreviewPackageEventState,
  type ProjectionPreviewProductAttributesState,
} from '@/modules/Itinerary/projectionPreviewInput'

type CurrencyMetadata = { exponent: number }
const currencies = CURRENCIES as Record<string, CurrencyMetadata>

export const initialProjectionPreviewStoreState = (): {
  projectionPreview: ProjectionPreviewInput | null
  projectionPreviewPackageEvents: ProjectionPreviewPackageEventState[]
} => ({
  projectionPreview: null,
  projectionPreviewPackageEvents: [],
})

export const buildProjectionPreviewStorePatch = async (previewInput: unknown) => {
  const input = parseProjectionPreviewInput(previewInput)
  const itinerary = await deserializeJsonApi(input.hydration.itinerary_document)
  const productAttributes = camelizeKeys(
    input.hydration.product_attributes,
  ) as ProjectionPreviewProductAttributesState
  const packageEvents = camelizeKeys(
    input.hydration.package_events,
  ) as ProjectionPreviewPackageEventState[]
  const currency = productAttributes.minimumCheckoutTierPricing.currency
  const pinnedExponent = productAttributes.commercialPreview.currencyExponent
  if (currencies[currency]?.exponent !== pinnedExponent) {
    throw new Error(`projection preview currency exponent conflicts with the shared ${currency} formatter`)
  }

  return {
    id: null,
    data: { ...productAttributes, itinerary },
    chatroomId: null,
    projectionPreview: input,
    projectionPreviewPackageEvents: packageEvents,
    reviews: [],
    customerReviewSummary: [],
  }
}
